/*
 *
 * OrdersPage actions
 *
 */

import { action, createAsyncAction } from 'typesafe-actions';

import { FulfillmentNote, MutationSubmitFeedbackArgs } from 'types/schema';
import ActionTypes from './constants';

export const orders = createAsyncAction(
  ActionTypes.FETCH_ORDERS_REQUEST,
  ActionTypes.FETCH_ORDERS_SUCCESS,
  ActionTypes.FETCH_ORDERS_FAILURE,
)<{}, {}, Error>();

export const ordersExportCSV = createAsyncAction(
  ActionTypes.ORDERS_EXPORT_CSV_REQUEST,
  ActionTypes.ORDERS_EXPORT_CSV_SUCCESS,
  ActionTypes.ORDERS_EXPORT_CSV_FAILURE,
)<{}, {}, Error>();

export const approveOrder = createAsyncAction(
  ActionTypes.APPROVE_ORDER_REQUEST,
  ActionTypes.APPROVE_ORDER_SUCCESS,
  ActionTypes.APPROVE_ORDER_FAILURE,
)<{}, {}, Error>();

export const disapproveOrder = createAsyncAction(
  ActionTypes.DISAPPROVE_ORDER_REQUEST,
  ActionTypes.DISAPPROVE_ORDER_SUCCESS,
  ActionTypes.DISAPPROVE_ORDER_FAILURE,
)<{}, {}, Error>();

export const reOrderSubmit = (data: any) => action(ActionTypes.REORDER, data);

export const reOrder = createAsyncAction(
  ActionTypes.REORDER_REQUEST,
  ActionTypes.REORDER_SUCCESS,
  ActionTypes.REORDER_FAILURE,
)<void, {}, Error>();

export const bulkReOrderSubmit = (data: any) => action(ActionTypes.BULK_REORDER, data);

export const bulkReorder = createAsyncAction(
  ActionTypes.BULK_REORDER_REQUEST,
  ActionTypes.BULK_REORDER_SUCCESS,
  ActionTypes.BULK_REORDER_FAILURE,
)<void, {}, Error>();

export const submitFeedback = (data: MutationSubmitFeedbackArgs['input']) => action(ActionTypes.RATE, data);

export const ratingAction = createAsyncAction(
  ActionTypes.RATE_REQUEST,
  ActionTypes.RATE_SUCCESS,
  ActionTypes.RATE_FAILURE,
)<void, {}, Error>();

export const fetchTabCounts = createAsyncAction(
  ActionTypes.FETCH_TAB_COUNTS_REQUEST,
  ActionTypes.FETCH_TAB_COUNTS_SUCCESS,
  ActionTypes.FETCH_TAB_COUNTS_FAILURE,
)<void, { pending: number; waiting: number }, Error>();

export const approveOrders = createAsyncAction(
  ActionTypes.APPROVE_ORDERS_REQUEST,
  ActionTypes.APPROVE_ORDERS_SUCCESS,
  ActionTypes.APPROVE_ORDERS_FAILURE,
)<string[], {}, Error>();

export const declineOrders = createAsyncAction(
  ActionTypes.DECLINE_ORDERS_REQUEST,
  ActionTypes.DECLINE_ORDERS_SUCCESS,
  ActionTypes.DECLINE_ORDERS_FAILURE,
)<string[], {}, Error>();

export const setFilter = (data: any) => action(ActionTypes.SET_FILTER, data);
export const applyFilter = (data: any) => action(ActionTypes.APPLY_FILTER, data);
export const clearFilter = () => action(ActionTypes.CLEAR_FILTER);
export const exportCSV = (data: any) => action(ActionTypes.EXPORT_CSV, data);
export const openModal = (data: FulfillmentNote) => action(ActionTypes.RATING_MODAL_OPEN, data);
export const closeModal = () => action(ActionTypes.RATING_MODAL_CLOSE);
export const loadMoreOrders = () => action(ActionTypes.LOAD_MORE_ORDERS);
